<template>
  <div>
    <CRUDList
      ref="crudList"
      :canAdd="false"
      :headers="headers"
      :displayTopPagination="false"
      :canEdit="false"
      :canSave="false"
      :showDate="true"
      :showTotal="true"
      :showDialog="false"
      :onSingleClickOpenDialog="true"
      :enableFixedHeaders="true"
      :selectedItems="selectedItems"
      :footerTotalDisplayColumnWise="[null,null,null,null,null,totals.total,
       totals.amount,totals.change]"
      :baseCrudKey="baseCrudKey"
      :defaultSortBy="defaultSortBy"
      @onSingleClicked="onSingleClicked"
      @emitSelectedItem="emitSelectedItem"
      tableWrapperDynamicClassname="elevation-3 ma-3 pa-3 taxroll-table-wrapper"
      tableDynamicClassname="taxroll-custom-table"
      tableDynamicHeight="130"
        :variableToChangeRowBgColor="dynamicRowBgColor"
    >
    </CRUDList>
  </div>
</template>

<script>
import {
  mapGetters, mapMutations, mapState,
} from 'vuex';
import { paymentDetailsTransactionListHeaders } from './paymentutils/PaymentTransactionTableHeaders';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import {
  amountToNumber,
  amountFormat,
} from '../../../util/shared/vue-global';
import '../../../assets/style.css';

export default {
  props: {
    baseCrudKey: {
      type: String,
      default: 'paymentTaxTransactionList',
    },
    paymentBaseCrudKey: {
      type: String,
      default: 'paymentTaxTransactionList',
    },
  },
  data() {
    return {
      headers: this.buildHeaders(),
    };
  },
  components: {
    CRUDList,
  },
  computed: {
    ...mapGetters('base/crud', [
      'items',
      'item',
    ]),
    ...mapState({
      storeSelItems: (state) => state.tax.taxPayment.selectedItemsBelowTable,
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
    }),
    selectedItems: {
      get() {
        return this.storeSelItems;
      },
      set(value) {
        this.setSelectedItemsBelowTable(value);
      },
    },
    totals() {
      const paymentItems = this.item(this.paymentBaseCrudKey);

      const totalAmt = amountToNumber(paymentItems.cashAmount || 0)
       + amountToNumber(paymentItems.checkAmount || 0)
       + amountToNumber(paymentItems.otherAmount || 0);
      let cashChanges = 0;
      if (paymentItems.cashChange) cashChanges = `Change of ${paymentItems.cashChange}`;
      if (!cashChanges && (amountToNumber(totalAmt) < amountToNumber(paymentItems.total))) {
        cashChanges = 'More money required';
      }

      return {
        total: amountFormat(paymentItems.total),
        amount: amountFormat(totalAmt),
        change: (cashChanges || null),
      };
    },
    defaultSortBy() {
      return [
        {
          column: 'paymentNumber',
          direction: 'desc',
        },
      ];
    },
    dynamicRowBgColor() {
      // Debug logging
      // Only return the background color configuration if the setting is enabled
      if (this.paymentSettingItem && this.paymentSettingItem.highlightCheckPaymentsWithNoImage) {
        const config = [{ varName: 'highlightNoFiles', varCol: '#82B1FF' }];
        return config;
      }
      return [];
    },
  },
  methods: {
    buildHeaders(showCert) {
      const useCert = showCert !== undefined
        ? showCert
        : ((this.paymentSettingItem || {}).showCertNumberOnPaymentScreen || false);
      return paymentDetailsTransactionListHeaders.map((h) => {
        if (h.value === 'reciept') {
          return useCert
            ? { ...h, text: 'Cert No', value: 'certNumber' }
            : h;
        }
        return h;
      });
    },
    ...mapMutations('tax/taxPayment', [
      'setSelectedItemsBelowTable',
    ]),
    onSingleClicked() {
      this.$emit('handleDialogItem');
    },
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
  },
  watch: {
    'paymentSettingItem.showCertNumberOnPaymentScreen': {
      handler(val) {
        this.headers = this.buildHeaders(val);
      },
      immediate: true,
    },
  },
};
</script>
